function Container ({ className, children }) {
    return (
        <div className={`max-w-xs mx-auto ${className || ''}`}>
            { children }
        </div>
    );
}

export default Container;